import {cognitoUserPoolsTokenProvider} from 'aws-amplify/auth/cognito';

import awsAuthErrorTypes from '../../consts/aws/awsAuthErrorTypes';
import log from '../logger/log';

// Browsers reject fetch with a TypeError when there is no network ("Failed to fetch" on Chrome/Android,
// "Load failed" on Safari/iOS), and Amplify wraps it into NetworkError.
export const getIsNetworkError = (error) => error?.name === awsAuthErrorTypes.NETWORK_ERROR;

const loadStoredTokens = () => cognitoUserPoolsTokenProvider.authTokenStore.loadTokens();

// fetchAuthSession() is not used for tokens: it also requests identity pool credentials and fails offline
// even with valid tokens. Expired tokens cannot be refreshed offline, so the stored ones are used meanwhile.
export const loadCurrentTokens = async () => {
    try {
        return await cognitoUserPoolsTokenProvider.getTokens();
    } catch (e) {
        if (!getIsNetworkError(e)) throw e;

        log.warn('cognitoTokenService: Failed to refresh tokens due to a network error, using stored tokens');

        return loadStoredTokens();
    }
};
